<template>
    <div class="menu-container">
        <div id="menu-head" class="menu-head">
            <button @click="categ_show = true" class="menu-toggle spin-button spin-button-spin"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg></button>
            <button @click="cart_show = true" class="menu-toggle spin-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>{{( cartSum/100 ).toFixed(2)}}</button>
        </div>
        <CategoryList :showing="categ_show" :categlist="categlist" :shops="shops" @categ_close="categ_show = false" @scrollto="tryScrollTo" @back="$emit('back')" :shop="shop"/>
        <CartWidget :showing="cart_show" @cart_close="cart_show = false" :cart="cart" @order="$emit('order')" :shop="shop"/>
        <div id="menu-wrapper" class="menu-wrapper">
            <MenuCategory :MenuCat="hitcateg" :shop="shop" />
            <MenuCategory v-for="item in Object.entries(menulist)" :key="item[0]" :MenuCat="item" :shop="shop"/>
        </div>
    </div>
</template>

<script>
import CategoryList from './CategoryList'
import MenuCategory from './MenuCategory'
import CartWidget from './CartWidget'

export default {
    props:['menulist', 'shops', 'shop', 'merchant'],
    data(){
        return {
            offset: 0,
            categ_show: false,
            cart_show: false
        }
    },
    methods:{
        moveScreenTo(id){
            let el = document.getElementById(id)
            let offset = this.getOffsetSum(el).top - document.getElementById('menu-head').offsetHeight - this.computed_offset 
            window.scrollTo({
                top: offset,
                behavior: "smooth"
            })
        },
        tryScrollTo(id){
            this.categ_show = false
            this.$nextTick(() => {
                this.moveScreenTo(id)
            })
            
        },
        getOffsetSum(elem) {
            var top=0, left=0
            while(elem) {
                top = top + parseFloat(elem.offsetTop)
                left = left + parseFloat(elem.offsetLeft)
                elem = elem.offsetParent       
            }
            return {top: Math.round(top), left: Math.round(left)}
        },
        handleScroll(){           
            if (this.offset == 0) {
                this.offset = this.getOffsetSum(document.getElementById('menu-head')).top - +this.computed_offset
            }

            /*if (this.categ_show == true) {
                this.categ_show = false
            }*/

            let header = document.getElementById('menu-head')
            if (window.scrollY > this.offset) {
                if (!header.classList.contains('fixed')) {
                    this.offset = this.getOffsetSum(document.getElementById('menu-head')).top - +this.computed_offset
                    header.classList.add('fixed')
                    header.style.top = this.computed_offset+'px'
                }
            } else if (header.classList.contains('fixed')) {
                header.classList.remove('fixed')
                header.removeAttribute('style')
            }
        },
        handleResize(){
            document.getElementById('menu-wrapper').style.marginTop = document.getElementById('menu-head').offsetHeight+'px'
        }
    },
    computed:{
        computed_offset(){
            return window.innerWidth < this.merchant.head_mobile_break ? this.merchant.head_mobile_offset : this.merchant.head_offset
        },
        flatlist(){
            let res = []
            for (let line of Object.entries(this.menulist)) {
                Array.prototype.push.apply(res, line[1]) 
            }
            return res
        },
        hitcateg(){
            return [this.shop.hitcateg_name, this.flatlist.filter(el => (el.ishit == 1))]
        },
        categlist: function () {
            let res = []
            for (let key of Object.entries(this.menulist)) {
                res.push(key[0])
            }
            return res
        },
        cart: function () {
            let res = []
            for (let line of Object.entries(this.menulist)) {
                Array.prototype.push.apply(res, line[1].filter(item => item.qty > 0)) 
            }
            return res
        },
        cartSum:function () {
            let amuont = 0
            for (let item of this.cart) {
                amuont += item.sum
            }
            return amuont
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('resize', this.handleResize)
        this.$nextTick(()=>{
            this.handleResize()
        })
    },
    updated(){
        this.$nextTick( function(){
            this.handleResize()
        })
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    components:{
        CategoryList,
        MenuCategory,
        CartWidget
    }
}
</script>